import { apiClient } from './client';

export interface GoogleCalendarStatus {
  connected: boolean;
  email: string | null;
}

export const getGoogleCalendarStatus = async (): Promise<GoogleCalendarStatus> => {
  const { data } = await apiClient.get('/google/status');
  return data.data;
};

/** Returns the Google consent URL — the caller navigates the browser to
 * it (`window.location.href = url`) rather than this function redirecting
 * itself, since it's a normal authenticated axios call (the actual
 * OAuth redirect/callback round-trip happens outside the SPA). */
export const getGoogleConnectUrl = async (): Promise<string> => {
  const { data } = await apiClient.get('/google/connect');
  return data.data.url;
};

export const disconnectGoogleCalendar = async (): Promise<void> => {
  await apiClient.post('/google/disconnect');
};

/** System Gmail integration (Phase 81) — a single system-level connection
 * (info@imcedu.com), completely separate from the per-counselor Calendar
 * connection above. Admin-only (master_data:view/update). */
export interface GmailStatus {
  connected: boolean;
  email: string | null;
  account: string;
}

export const getGmailStatus = async (): Promise<GmailStatus> => {
  const { data } = await apiClient.get('/google/gmail/status');
  return data.data;
};

export const getGmailConnectUrl = async (): Promise<string> => {
  const { data } = await apiClient.get('/google/gmail/connect');
  return data.data.url;
};

export const disconnectGmail = async (): Promise<void> => {
  await apiClient.post('/google/gmail/disconnect');
};
